import Endereco from "./endereco";
import Contato from "./contato";
import DadosPessoais from "./dadosPessoais";

export default class Candidato {
  constructor(modalidade = '', classificacao = '',endereco = new Endereco(), contato = new Contato(), dadosPessoais=new DadosPessoais()) {
    this.modalidade = modalidade;
    this.endereco = endereco;
    this.contato = contato;
    this.classificao = classificacao;
    this.dadosPessoais = new DadosPessoais(dadosPessoais.id,dadosPessoais.nome, dadosPessoais.nomeSocial, dadosPessoais.cpf, dadosPessoais.rg, dadosPessoais.curso, dadosPessoais.raca);
  }
}
